module.exports = __webpack_public_path__ + "static/media/teamWork.a79227f6.jpg";